import Request from "./request";
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'
import consts from "@/consts";

async function fetch(data) {
    return Request('get', "api/requisitions/index", data);
}

async function fetchOne(id,data) {
    return Request('get', "api/requisitions/view/" + id, data)
}

async function getReturnableList(id) {
    return Request('get', "api/requisitions/get-returnable-list/" + id)
}

async function requisitionStockMaterials(data) {
    return Request('get', "api/requisitions/get-requisition-stock-materials/", data)
}

async function cancel(id) {
    return Request('delete', "api/requisitions/cancel/" + id )
}

async function approve(id) {
    return Request('get', "api/requisitions/approve/" + id )
}

async function add(data) {
    return Request('post', "api/requisitions/add", data)
}

async function edit(data) {
    return Request('patch', "api/requisitions/edit", data)
}

async function returnSave(data) {
    return Request('post', "api/requisitions/returnSave", data)
}

async function getIntelligentDetails(data) {
    return Request('patch', "api/requisitions/get-intelligent-details", data)
}

async function addViews(data) {
    return Request('post', "api/requisitions/add-views", data)
}

async function editLogistics(id, data) {
    // 修改调拨物流
    return Request("post","api/requisitions/edit-logistics/" + id , data)
}

// 详情导出
async function exportDetail(id){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/requisitions/detail-export/" + id);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

// 三联详情导出
async function exportSanlianDetail(id){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/requisitions/sanlianDetailExport/" + id);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function getRequisitionLogistic(data) {
    // 出入库单获取调拨单
    return Request("get","api/requisitions/get-requisition-logistic/", data)
}

async function editExpressPrice( data) {
    return Request('post', 'api/requisitions/editExpressPrice', data)
}

async function getPricingMaterials(data, pageType = 'in') {
    if (pageType == 'in') {
        return Request('get', 'api/requisitions/get-pricing-materials', data)
    } else if (pageType == 'out') {
        return Request('get', 'api/requisitions/get-out-pricing-materials', data)
    }
}

async function getPricingOrders(data, pageType = 'in') {
    if (!data) data = {};
    data.limit = consts.limitAll; // 获取全部
    data.itemsPerPage = consts.limitAll // 获取全部
    data.page = 1;
    if (pageType == 'in') {
        return Request('get', 'api/requisitions/get-pricing-orders', data)
    } else if (pageType == 'out') {
        return Request('get', 'api/requisitions/get-out-pricing-orders', data)
    }
}

async function orderPricing(data, pageType = 'in') {
    if (pageType == 'in') {
        return Request('post', "api/requisitions/in-batch-pricing", data);
    } else if (pageType == 'out') {
        return Request('post', "api/requisitions/out-batch-pricing", data);
    }
}

async function requisitionPricingTemplateExport(data, pageType = 'in') {// 导出批量核价信息
    store.dispatch("fullscreenLoading");
    let response = null
    if (pageType == 'in') {
        response = await Request('get', "api/requisitions/in-pricing-export", data);
    } else if (pageType == 'out') {
        response = await Request('get', "api/requisitions/out-pricing-export", data);
    }
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function orderPricingImport(file, pageType = 'in') {// 导入批量核价
    var data = new FormData();
    data.append("excel", file);
    if (pageType == 'in') {
        return Request('post', "api/requisitions/in-pricing-import", data);
    } else if (pageType == 'out'){
        return Request('post', "api/requisitions/out-pricing-import", data);
    }
}

async function batchApprove(data) {
    //批量审批
    return Request('get', 'api/requisitions/batch-approve', data, false, false, true)
}

async function saveExpress(id, data) {
    return Request('post', "api/requisitions/edit-express-price/" + id, data);
}

export default {
    fetch,
    fetchOne,
    getReturnableList,
    requisitionStockMaterials,
    cancel,
    approve,
    add,
    edit,
    returnSave,
    getIntelligentDetails,
    addViews,
    editLogistics,
    exportDetail,
    getRequisitionLogistic,
    exportSanlianDetail,
    editExpressPrice,
    getPricingMaterials,
    getPricingOrders,
    orderPricing,
    requisitionPricingTemplateExport,
    orderPricingImport,
    batchApprove,
    saveExpress,
};